export default __webpack_public_path__ + "static/media/edit-one.783032bf.svg";